import Component from '../abstracts/Component';

export default class CartComponent extends Component {

  get SELECTORS() {
    return {
      cart: '[data-cart-wrapper]',
      qtyBtn: '[data-cart-add-remove]',
      more: '[data-cart-more]',
      less: '[data-cart-less]',
      qty: '[data-cart-qty]',
      shippingRadios: '[data-shipping-method] input[type=radio]',
      shippingRadiosBox: '[data-shipping-method]',
      options_checkbox_prefix: "shipping-",
      storeLocator: "[data-storelocator]",
      storeInput: ".stores-list input[name='deliveryMethodStore']",
      storeRadio: "[data-store-name]",
      storeCard: ".store-card",
      cartAlertBox: '[data-notification]',
      cartAlert: '.js-cart-alert',
      storesList: '#results-list-container',
      storeLocatorErrorMessage: '.store-not-selected-message',
      shipmentBoxes: '.shipment-col'
    }
  }

  get CLASSES() {
    return {
      checked: 'checked',
      active: 'active',
      inactive: 'inactive',
      lastItem: 'remove-last',
      disabled: 'disabled',
      show: 'show'
    };
  }

  constructor(compEl) {
    super(compEl);
    this.y = 0;
    this.quantityBoxes = this.$component.querySelectorAll(this.SELECTORS.qtyBtn);
    this.shippingRadios = this.$component.querySelectorAll(this.SELECTORS.shippingRadios);
    this.storeLocator = this.$component.querySelector(this.SELECTORS.storeLocator);
    this.cartAlert = this.$component.querySelector(this.SELECTORS.cartAlert);
    this.cartAlertBox = this.$component.querySelector(this.SELECTORS.cartAlertBox);
    this.storesList = this.$component.querySelector(this.SELECTORS.storesList);
    this.storeLocatorErrorMessage = this.$component.querySelector(this.SELECTORS.storeLocatorErrorMessage);
    this.shipmentBoxes = this.$component.querySelector(this.SELECTORS.shipmentBoxes);
  }

  quantityManager() {
    // update url
    let updateQtyUrl = document.querySelector(this.SELECTORS.cart).getAttribute('data-update-qty-url');
    // quantity box looop
    this.quantityBoxes.forEach(quantityBox => {
      let addBtn = quantityBox.querySelector(this.SELECTORS.more);
      let removeBtn = quantityBox.querySelector(this.SELECTORS.less);
      //
      addBtn.addEventListener('click', () => {
        if (!addBtn.classList.contains(this.CLASSES.disabled) && !addBtn.classList.contains(this.CLASSES.inactive)) {
          addBtn.classList.add(this.CLASSES.inactive);
          quantityBox.setAttribute('data-qty', parseInt(quantityBox.getAttribute('data-qty'),10) + 1);

          // save focus only for keyboard navigation
          if (window.__lastInteractionWasKeyboard) {
            const focusId = addBtn.dataset.focusId;
            if (focusId) sessionStorage.setItem('cartFocusId', focusId);
          }

          location.href = updateQtyUrl + "&entryNumber=" + quantityBox.getAttribute('data-entry-number') + "&qty=" + quantityBox.getAttribute('data-qty');
        }
      });

      //
      removeBtn.addEventListener('click', (e) => {
        let btn = (e.target.localName === 'i') ? e.target.parentNode : e.target;
        if (parseInt(quantityBox.getAttribute('data-qty'), 10) > 0 &&
            !btn.classList.contains(this.CLASSES.lastItem) &&
            !btn.classList.contains(this.CLASSES.inactive)) {

          btn.classList.add(this.CLASSES.inactive);
          quantityBox.setAttribute('data-qty', parseInt(quantityBox.getAttribute('data-qty'), 10) - 1);

          // save focus only for keyboard navigation
          if (window.__lastInteractionWasKeyboard) {
            const focusId = btn.dataset.focusId;
            if (focusId) sessionStorage.setItem('cartFocusId', focusId);
          }

          location.href = updateQtyUrl + "&entryNumber=" + quantityBox.getAttribute('data-entry-number') + "&qty=" + quantityBox.getAttribute('data-qty');
        }
      });
    });
  }

  // show or hide store locator
  showOrHideStoreLocator(hide){
    if(this.storeLocator !== null) {
      if (hide) {
        this.storeLocator.classList.add("d-none");
      } else {
        this.storeLocator.classList.remove("d-none");
      }
    }
  }

  //
  clickCollectStoreSelection(event) {
    // click collect select store
    this.$on('click', ({event}) => {
      // input clicked
      let input = event.currentTarget.parentElement.querySelector('input');

      // remove error message in C&C section
      console.log('[CartController] Hiding isStoreNotSelectedError');
      this.storeLocatorErrorMessage.classList.add("hidden");
      this.shipmentBoxes.classList.remove("error");

      // submit selection
      this.submitAjaxCartForm(input);
    }, 'body', this.SELECTORS.storeInput);
  }

  // update delivery method by input
  /* TODO: StoreLocator logic, not needed atm
  updateDeliveryMethod(event) {
     let stores = $('.ib_sl-store-item input');
     stores.each((index, store) => {
        store.checked = false;
      }
     )
    // input clicked
    let input = event.currentTarget.parentElement.querySelector('input');
    //
    this.submitAjaxCartForm(input);
  }

  // ajax call to update delivery method
  submitAjaxCartForm(input) {
    // remove error message in C&C section
    this.storeLocatorErrorMessage.classList.add("hidden");
    this.shipmentBoxes.classList.remove("error");
    let deliveryMethod = input.value;
    let selectedStore = '';
    if (input.getAttribute('data-click-collect')) {
      selectedStore = input.getAttribute('id');
    }
    // go ajax
    fetch(
      `${document.location.href}?set-delivery-mode=updateDelivery&code=${deliveryMethod}&selectedStore=${selectedStore}`,
      {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
      }
    ).then(res => {
      return res.text();
      }
    ).then( data =>{
      console.log('[CartController]fetch done:', deliveryMethod,selectedStore);
      let html = new DOMParser().parseFromString(data, 'text/html');
      // Searching errors
      let isStoreNotSelectedError = (html.querySelector('.store-not-selected-flag') !== null);
      console.log("isStoreNotSelectedError: " + isStoreNotSelectedError);
      // Showing errors in C&C section
      if (isStoreNotSelectedError){
          console.log('[CartController] Showing isStoreNotSelectedError');
          this.storeLocatorErrorMessage.classList.remove("hidden");
          this.shipmentBoxes.classList.add("error");
      }
    });
  }
*/
  initSimpleBar(SimpleBar) {
    const itemsContainer = this.storesList;
    this.simpleBar = new SimpleBar(itemsContainer, {
      autoHide: false,
    });
  }


  restoreFocus() {
    const focusId = sessionStorage.getItem('cartFocusId');
    if (focusId) {
      const focusTarget = this.$component.querySelector(`[data-focus-id="${focusId}"]`);
      if (focusTarget) {
        focusTarget.focus();
        focusTarget.setAttribute("data-focused", "true");
      }
      sessionStorage.removeItem('cartFocusId');
    }
  }

  bindEvents() {
    this.quantityManager();
    window.__lastInteractionWasKeyboard = false;

document.addEventListener('keydown', (e) => {
  if (!['Shift', 'Alt', 'Meta', 'Control'].includes(e.key)) {
    window.__lastInteractionWasKeyboard = true;
  }
});

document.addEventListener('mousedown', () => {
  window.__lastInteractionWasKeyboard = false;
});
    document.addEventListener('click', () => {
      const focusedElement = document.querySelector('[data-focused="true"]');
      if (focusedElement) {
        focusedElement.removeAttribute('data-focused');
      }
    });

    document.addEventListener('keydown', () => {
      const focusedElement = document.querySelector('[data-focused="true"]');
      if (focusedElement) {
        focusedElement.removeAttribute('data-focused');
      }
    });
    this.restoreFocus();
/* TODO: StoreLocator logic, not needed atm

    // clicks on radio
    this.shippingRadios.forEach(checkbox => {
      // if is
      let isClickAndCollectCheckbox = checkbox.id.includes("Click-and-Collect");
      // listen to the click
      checkbox.addEventListener('change',(event) => {
        // hide/show store locator
        this.showOrHideStoreLocator(!isClickAndCollectCheckbox);
        // update delivery method if not click and collect
        this.updateDeliveryMethod(event);
        // change method class
        let checboxBoxChecked = document.querySelector(this.SELECTORS.shippingRadiosBox+'.'+this.CLASSES.checked);
        let checboxBox = checkbox.closest(this.SELECTORS.shippingRadiosBox);
        // remove class from checked
        checboxBoxChecked.classList.remove(this.CLASSES.checked);
        // add class to selected
        checboxBox.classList.add(this.CLASSES.checked);
      });
    });

    // on show results
    this.$on(this.$customEvents.O2O.ccStoresShowResults,(e) => {
      // function to listen radio change
      this.clickCollectStoreSelection(e);
    });

    // click and collect selecting store
    this.$on('click', ({event}) => {
      // search parent li
      let radioBox = event.target.closest('li');
      // check if box is active
      if (radioBox.classList.contains(this.CLASSES.active)) {
        return;
      }
      // check click on more details
      if (event.target.className === 'store-card__content__details__actions'
        || event.target.hasAttribute(this.SELECTORS.more)
        || event.target.hasAttribute(this.SELECTORS.less)
        ) return;
      // remove active from actual active
      let storeChecked = document.querySelector(this.SELECTORS.storeCard+'.'+this.CLASSES.active);
      if (storeChecked != null) {
        storeChecked.classList.remove(this.CLASSES.active);
      }
      // add active class
      radioBox.classList.add(this.CLASSES.active);
      // select radio in the box clicked if is not clicked on radio or label
      if (event.target.nodeName != 'INPUT' && event.target.nodeName != 'LABEL') {
        let storeRadio = radioBox.querySelector(this.SELECTORS.storeRadio);
        storeRadio.click();
      }
    },'body', this.SELECTORS.storeCard);
*/
    // cart alerts
    if (this.cartAlert !== null && this.cartAlertBox !== null) {
      this.cartAlertBox.classList.add(this.CLASSES.show);
      setTimeout(() => {
        this.cartAlertBox.classList.remove(this.CLASSES.show);
      }, 6000)
    }

    if (this.cartAlert !== null && this.cartAlertBox !== null) {
      this.cartAlertBox.height
      this.cartAlertBox.classList.add(this.CLASSES.show);
      setTimeout(() => {
        this.cartAlertBox.classList.remove(this.CLASSES.show);
      }, 6000)
    }

    /* TODO: StoreLocator logic, not needed atm
    let isStoreNotSelectedError = this.$component.querySelector('[data-no-store-selected]') !== null;
    console.log("isStoreNotSelectedError: " + isStoreNotSelectedError);
    // Showing errors in C&C section
    if (isStoreNotSelectedError){
        console.log('[CartController] Showing isStoreNotSelectedError');
        this.storeLocatorErrorMessage.classList.remove("hidden");
        this.shipmentBoxes.classList.add("error");
    }*/

  }

  render() {
    this.bindEvents();
  }
}

